const Switch = () => {
  return {
    MuiSwitch: {
      styleOverrides: {
        root: ({ theme }) => ({
          '& .MuiSwitch-track': {
            backgroundColor: `rgb(${theme.palette.customColors.mainChannel})`
          }
        })
      }
    }
  }
}

export default Switch
